import * as api from './api';

const actions = {
    /**
     * Check if member has already added course into his wishlist.
     *
     * @param type
     * @param id
     * @returns {Promise}
     */
    checkIfAddedToWishlist({}, {type, id}) {
        return new Promise((resolve, reject) => {
            axios.get(api.checkIfAdded(type, id))
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response))
        });
    },

    /**
     * Add item to member wishlist
     *
     * @param item [Course]
     * @param wishlistType [currently support course only]
     * @returns {Promise}
     */
    addItem({}, {item, wishlistType}) {
        return new Promise((resolve, reject) => {
            axios.post(api.addToWishlist, {item, wishlistType})
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    }
};

export default {
    namespaced: true,
    actions
};